export default "__VITE_ASSET__CqopHree__"